import React from 'react';
import BaseButton from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT } from '../../enum/formProps';

interface ButtonProps {
  text: string;
  variant?: BUTTON_VARIANT;
  type?: BUTTON_TYPE;
  color?: BUTTON_COLOR;
  size?: BUTTON_SIZE;
  onClick?: () => void;
  startIcon?: object;
  endIcon?: object;
  disabled?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <BaseButton
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      onClick={props.onClick}
      color={props.color}
      variant={props.variant}
      type={props.type}
      size={props.size}
      disabled={props.disabled}
      className={props.className}
    >
      {t(props.text)}
    </BaseButton>
  );
};

export default Button;
